import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NotificationService } from 'app/services/notification.service';
import { Notification } from 'app/models/notification';

@Component({
    selector: 'notification-bell',
    templateUrl: './notification-bell.component.html',
    styleUrls: ['./notification-bell.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NotificationBellComponent implements OnInit, OnDestroy {
    unreadCount: number = 0;
    notifications: Notification[] = [];
    showPanel: boolean = false;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private notificationService: NotificationService,
        private router: Router
    ) {}

    ngOnInit(): void {
        // Suscribirse al contador de notificaciones no leídas
        this.notificationService.unreadCount$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(count => {
                this.unreadCount = count;
            });

        // Obtener notificaciones recientes cuando se abre el panel
        this.notificationService.notifications$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(notifications => {
                this.notifications = notifications;
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    /**
     * Toggle del panel de notificaciones
     */
    togglePanel(): void {
        this.showPanel = !this.showPanel;
        
        if (this.showPanel) {
            // Cargar notificaciones recientes al abrir
            this.notificationService.getRecentNotifications().subscribe();
        }
    }

    /**
     * Marcar notificación como leída
     */
    onNotificationClick(notification: Notification): void {
        if (!notification.read_at) {
            this.notificationService.markAsRead(notification.id).subscribe();
        }
    }

    /**
     * Marcar todas como leídas
     */
    markAllAsRead(): void {
        this.notificationService.markAllAsRead().subscribe(() => {
            this.notificationService.getRecentNotifications().subscribe();
        });
    }

    /**
     * Ver todas las notificaciones
     */
    viewAllNotifications(): void {
        this.router.navigate(['/notifications']);
        this.showPanel = false;
    }

    /**
     * Obtener tiempo relativo
     */
    getRelativeTime(dateString: string): string {
        const date = new Date(dateString);
        const now = new Date();
        const diff = now.getTime() - date.getTime();
        
        const minutes = Math.floor(diff / 60000);
        const hours = Math.floor(diff / 3600000);
        const days = Math.floor(diff / 86400000);

        if (minutes < 1) return 'Justo ahora';
        if (minutes < 60) return `Hace ${minutes} min`;
        if (hours < 24) return `Hace ${hours}h`;
        if (days < 7) return `Hace ${days}d`;
        
        return date.toLocaleDateString();
    }
}
